import { getEl } from './dom.js';
import { closeModal, visibleModal } from './modal.js';
import Mustache from 'mustache';

import palettes from 'bundle-text:./data/colours.json';
export const PALETTES = JSON.parse(palettes);

export function setupPalette() {

  // Setup palette modal
  const paletteTemplate = getEl('paletteModalTemplate').innerHTML;
  getEl('modalTarget').innerHTML = Mustache.render(paletteTemplate, PALETTES);

  document.querySelectorAll('#paletteModal li').forEach(item => {
    item.addEventListener('click',
      () => {
        let paletteDom = getEl('palette');
        paletteDom.value = item.getAttribute('data-index');
        paletteDom.dispatchEvent(new Event("change"));
        closeModal(visibleModal);
      }, false
    );
  });

  // Add palettes to dropdown
  if (getEl("palette")) {
    for (let x of PALETTES.palettes) {
      if (x.index == 12) {
        continue;
      }
      var sel = document.createElement("option");
      sel.innerHTML = x.name;
      sel.value = x.index;
      getEl("palette").appendChild(sel);
    }
  }
}